import ReactGA from "react-ga4";
import { isLocalDevelopment } from "../constants/environment";

const safeGAEvent = (eventPayload) => {
  if (!isLocalDevelopment()) {
    try {
      ReactGA.event(eventPayload);
    } catch (error) {
      console.error("Analytics event error:", error, eventPayload);
    }
  }
};

export const ClickActionEvent = (action, category, label) => {
  safeGAEvent({
    category: category,
    action: action + " clicked",
    label: label,
  });
};

// UPI Expense Calculator Analytics Events
export const UPIEvents = {
  ClickActionEvent,
  // Upload flow
  uploadInitiated: (source = 'file_select') => {
    if (!isLocalDevelopment()) {
      ReactGA.event({
        category: 'UPI_Expense_Calculator',
        action: 'upload_initiated',
        label: source,
      });
    }
  },

  statementTypeDetected: (type) => {
    if (!isLocalDevelopment()) {
      ReactGA.event({
        category: 'UPI_Expense_Calculator',
        action: 'statement_type_detected',
        label: type, // 'phonepe' or 'gpay'
      });
    }
  },

  statementTypeSelected: (type) => {
    if (!isLocalDevelopment()) {
      ReactGA.event({
        category: 'UPI_Expense_Calculator',
        action: 'statement_type_manual_select',
        label: type,
      });
    }
  },

  passwordProtectedPDF: () => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'password_protected_pdf_encountered',
    });
  },

  passwordSubmitted: (success) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'password_submitted',
      label: success ? 'success' : 'failed',
    });
  },

  // Processing & Dashboard
  processingStarted: (transactionCount) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'processing_started',
      value: transactionCount,
    });
  },

  dashboardViewed: (totalSpend, transactionCount, statementType) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'dashboard_viewed',
      label: statementType,
      value: transactionCount,
    });
  },

  demoDataLoaded: () => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'demo_data_loaded',
    });
  },

  // Feature interactions
  merchantClicked: (category) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'merchant_clicked',
      label: category,
    });
  },

  dateFilterApplied: (filterType, fromDate, toDate) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'date_filter_applied',
      label: filterType,
    });
  },

  sortChanged: (field, order) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'sort_changed',
      label: field,
      value: order,
    });
  },

  filterCleared: (filterType) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'filter_cleared',
      label: filterType,
    });
  },

  merchantDialogOpened: (category) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'merchant_dialog_opened',
      label: category,
    });
  },

  merchantsListToggled: (state) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'merchants_list_toggled',
      label: state, // 'expanded' or 'collapsed'
    });
  },

  categoryChartViewed: (totalCategories) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'category_chart_viewed',
      value: totalCategories,
    });
  },

  trendGraphViewed: () => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'trend_graph_viewed',
    });
  },

  smartInsightsViewed: (insightCount) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'smart_insights_viewed',
      value: insightCount,
    });
  },

  // Error tracking
  uploadError: (errorType, errorMessage) => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'upload_error',
      label: errorType,
    });
  },

  autoDetectFailed: () => {
    safeGAEvent({
      category: 'UPI_Expense_Calculator',
      action: 'auto_detect_failed',
    });
  },
};

export const ResumeEvents = {
  resumePageViewed: () => {
    safeGAEvent({
      category: 'Resume',
      action: 'resume_page_viewed',
    });
  },
  resumeDownloadPdf: () => {
    safeGAEvent({
      category: 'Resume',
      action: 'resume_download_pdf',
    });
  },
  resumeDownloadImage: () => {
    safeGAEvent({
      category: 'Resume',
      action: 'resume_download_image',
    });
  },
};

// Builder labels are product choices only. Never pass user text, filenames or image data.
export const ResumeBuilderEvents = {
  track: (action, label) => {
    safeGAEvent({
      category: 'Resume_Builder',
      action,
      ...(label ? { label } : {}),
    });
  },
};
